import PaymentAbstractDialog from "./PaymentAbstractDialog";

import SelectClient from "components/SelectClient";

export default class TransferPaymentDialog extends PaymentAbstractDialog {

    title = "invoice.transferPayment";
    dialogSaveLabel = "invoice.transferFunds";

    get balanceLabel() {
        return "invoice.transferSource";
    }

    showZeroItem() {
        return false;
    }

    validInfo() {
        return !!this.state.targetClientId;
    }

    joinSaveInfo(info) {
        const { targetClientId } = this.state;

        return {
            ...info,
            direction: "DIRECTION_CREDIT",
            targetClientId,
        };
    }

    onClientChange(client) {
        this.state.targetClientId = client?.id || null;

        this.changeValue(this.state.value);
    }

    renderMainBlock() {
        return (
            <div className="flex col gap8">
                <div className="text p2 rowInfoTitle">{this.tr("invoice.fundRecipient")}</div>
                <SelectClient
                    currentClient={this.state.targetClientId}
                    searchShow={true}
                    onClick={this.onClientChange.bind(this)}
                />
            </div>
        );
    }
}
